import { Component, OnDestroy, OnInit,  EventEmitter, Input, Output, ViewContainerRef, OnChanges} from '@angular/core';
import { ReactiveFormsModule, FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import {DemoService} from '../../../../demo.service';
import {Routes, RouterModule, Router} from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
// Notifications
import { HotToastService } from '@ngneat/hot-toast';
import { JobTypeCourt } from '../../../../shared/models/jobTypeCourt.model';

import { CreateJobTypeComponent} from './../create-job-type.component';

import { BsModalService } from 'ngx-bootstrap/modal';



// import { Observable } from 'rxjs/Observable'; // this created errors ats use below
import {Observable, Subject, map, Subscription} from 'rxjs';


@Component({
  selector: 'app-update-court',
  templateUrl: './update-court.component.html',
  styleUrls: ['./update-court.component.css']
})
export class UpdateCourtComponent implements OnInit, OnChanges {
  model: any;
  job_types: any;
  job_type_locations: any;
  count2: any;
  get_latest_court_id: any;
  job_type_court: any;

  @Input() intialCount = 221;
  @Input() count = this.intialCount;
  // sees if there is a change in myCount
@Output()
change: EventEmitter<number> = new EventEmitter<number>();
  job_type: Object;
  @Output('closeParentModel') closeParentModel: EventEmitter<any> = new EventEmitter();

  constructor(
    private http: HttpClient,
    private _demoService: DemoService,
    private route: ActivatedRoute,
    private router: Router,
    public toastr: HotToastService,
    // vcr: ViewContainerRef,

    private modalService: BsModalService, 
    // viewRef: ViewContainerRef
  ) { }

  ngOnChanges() {
    this.change.emit(this.intialCount);
   // this.getTraceCandidate(this.count);
   this.model = new JobTypeCourt();
   this.model = this.getJobTypeCourt(this.count);
   this.getJobTypes();
   


  }

  ngOnInit() {
  }

  getJobTypes() {
    this._demoService.getJobTypes().subscribe(
       data => { this.job_types = data; },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }
  
  
   getJobTypeLocations(job_type_id) {
    this._demoService.getJobTypeLocations(job_type_id).subscribe(
       data => { this.job_type_locations = data; },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }
  

   sendJobTypeLocationsID(job_type_id) {
    // this.initialCount = this.trace_candidates.trace_candidate_id;
    this.count2 = job_type_id;
    this.getJobTypeLocations(this.count2); // updates the selected job ID....
    // this.model.job_type_location_id = 1;
   // this.model.job_type_court_id = 0;
    // this.model.job_type_document_type_id = 0;
    // this.model.job_type_affidavit_type_id = 0;

  }


  getJobTypeCourt(job_type_court_id) {
    this._demoService.getJobTypeCourt(job_type_court_id).subscribe(
       data => { this.job_type_court = data; 
        let res = data[0];
       // this.model.job_type_id = res.job_type_id;
        this.getJobTypeLocations(res.job_type_id);
      
      
      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }



   getJobType(job_type_id) {
    this._demoService.getJobType(job_type_id).subscribe(
       data => { 
        this.job_type = data;
      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }


   updateJobCourt(model) {
    this._demoService.updateJobCourt(model).subscribe(
       data => {
       // console.log(model);
         // this.trace_candidate_update = data;
       this.toastr.success('Court Updated');
       // Subject to reload the manager component parent.
      // CreateJobTypeComponent.returned.next(false);
      this.closeParentModel.emit();
         return true;
       },
       error => {
         console.error('Error saving Client!');
         return console.error(error);
       }
      // err => console.error(err),
      // () => console.log('done updates')
    );
    }
    




}
